import BaseClass from "./BaseClass";
import FullscreenModal from "./modals/FullscreenModal";

const defaultOptions = {};

export default class Package extends BaseClass {

    constructor(options)
    {
        super(options, defaultOptions);
        this.init();
    }

    init()
    {}

    /**
     * Function that removes package/cure from cart
     *
     * @param {Element} e clickable element for removing, contains data
     * @param {String} currency current currency
     * @param {String} roomId
     */
    removePackageCure(e, currency, roomId)
    {
        let count = $(e).data('count');
        let idNumber = $(e).data('id');
        let type = $(e).data('type');
        let idString = count+'-'+type+'-'+idNumber;
        let locale = $('meta[name="country"]').attr('content');

        $.ajax({
            headers: {'X-App-Locale': locale},
            url: window.origin+'/api/remove/cure/to_room',
            method: 'POST',
            data: {
                'id': idNumber,
                'type': type,
                'roomID': roomId
            },
            success: function (data) {
                // if it is the last row then delete whole part of the output table
                if ($(e).closest('table.treatment_info').find('tr.table-row').length === 1) {
                    $(e).closest('table.treatment_info').remove();
                }

                $('#'+idString).remove();
            }
        });
    }

    /**
     * This function will fetch content for treatment adding to cart modal and view the modal.
     *
     * @param {String} treatmentType
     * @param {Number} treatmentId
     */
    showTreatmentAddModal(treatmentType, treatmentId)
    {
        $.ajax({
            url: window.location.origin + '/api/get/modal/' + treatmentType + '/' + treatmentId,
            method: 'GET',
            data: {
                'count': window.priceCounters[treatmentType + '_' + treatmentId].getCount(),
                '_token': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'json',
            success: (returnData) => {
                $('[data-fullscreen-modal="treatment_add"]').html(returnData.view);
                $("#treatment_add").modal('show');
            }
        });
    }
}
